(function ($) {
    function lazyLoadImg() {
        $(".c03-carousel img").each(function () {
            if ($(this).parentsUntil().hasClass("slick-active")) {
                if ($(this).hasClass("lazy") && $(this).attr("src") == "") {
                    $(this).removeClass("lazy");
                    $(this).attr("src", $(this).attr("data-src"));
                }
            }
        });
    }
    $(window).on('load', function () {
        lazyLoadImg();
    });
    initCarousels();
    disableAutoTagging();
    bindEvents();
    var videoLoaded = false;
    document.addEventListener('DOMContentLoaded', function (event) {
        videoLoaded = true;
    });

    function initCarousels() {
        if (!$.fn.slick) return;

        $("#clPagerList").remove();
        //get all element which has attribute "data-slide-info" and remove style display none
        $('[data-slide-info]').removeAttr('style');

        $('.carousel').each(function () {
            var self = $(this);
            var useThumbs = self.hasClass('carousel-thumb');
            /**chem merge*/
            var custom = self.data('options');
            /**chem merge*/
            var defaults = {
                /**chem merge*/
                dots: custom.ismultislideCarousel ? false : true,
                /**chem merge*/
                accessibility: true,
                pauseOnDotsHover: true,
                useAutoplayToggleButton: false,
                infinite: custom.ismultislideCarousel ? false : true,
                initialSlide: 0,
                /**chem merge*/
                arrows: true,
                slidesToShow: custom.ismultislideCarousel ? custom.slidestoShow : 1,
                slidesToScroll: custom.ismultislideCarousel ? custom.slidestoScroll : 1,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: custom.ismultislideCarousel ? custom.slidestoShowMobile : 1,
                            slidesToScroll: custom.ismultislideCarousel ? custom.slidestoScrollMobile : 1
                        }
                    }
                ],
                /**chem merge*/
                customPaging: function (slider, i) {
                    var pager;
                    var data = $(slider.$slides[i]).data('slide-info');
                    var arialabel;
                    if (data.arialabel) {
                        arialabel = data.arialabel;
                    }
                    else {
                        arialabel = "Slider " + parseInt(i + 1) + ' of ' + $(slider.$slides).length + '"';
                    }
                    if (useThumbs) {
                        var alt = data.alt || data.caption;
                        pager = '<a href="javascript:;" class="pager"  aria-label="' + arialabel + '"';
                        pager += ' title="' + alt + '"><img src="' + data.image + '" alt="' + alt + '"><p>' + data.caption + '</p>';
                    } else {
                        pager = '<a href="javascript:;" class="pager"  aria-label="' + arialabel + '"';
                        pager += '>';
                    }
                    return pager + '</a>';
                }
            };
            var options = $.extend(defaults, custom);
            /**chem merge*/
            /* Randomize slides on load */
            if (options.randomizeSlides != undefined && options.randomizeSlides) {
                var rand = Math.floor(getRandomFloat() * options.numberOfSlides);
                options.initialSlide = rand;
            }

            /* Including to fix fortify issue for random on load */
            function getRandomFloat() {
                var buffer = new ArrayBuffer(8);
                // View it as an Int8Array and fill it with 8 random ints
                var ints = new Int8Array(buffer);
                window.crypto.getRandomValues(ints);
                // Set the sign (ints[7][7]) to 0 and the
                // exponent (ints[7][6]-[6][5]) to just the right size
                // (all ones except for the highest bit)
                ints[7] = 63;
                ints[6] |= 0xf0;
                // Now view it as a Float64Array, and read the one float from it
                var float = new DataView(buffer).getFloat64(0, true) - 1;
                return float;
            }
            /**chem merge*/
            self.slick(options);

            /**chem merge*/
            /* Sort slides based date published on load */
            if (options.enableDateSort != undefined && options.enableDateSort) {
                var slider = $('.slick-slider');
                var slides = slider.find('.slick-slide');

                slides.each(function (sli) {
                    if ($(slides[sli]).find('.b03-image').length !== 0) {
                        var val1 = $(slides[sli]).find('.b03-image').attr('data-updateddate');
                        $(slides[sli]).attr("data-updateddate", val1);
                    }
                });

                var slide2 = [];
                var slideon = slides.map(function (sli) {
                    if ($(slides[sli]).hasClass("slick-cloned")) {
                        return false;
                    } else {
                        return slide2.push($(slides[sli]));
                    }
                });

                var sortedSlides = Array.from(slide2).sort(function (a, b) {
                    var dateA = a[0].dataset.updateddate;
                    var dateB = b[0].dataset.updateddate;
                    return dateB.localeCompare(dateA);
                });

                $('.slick-slider').slick('slickRemove', 0, $('.slick-slider .slick-slide').length);

                // Add sorted slides to the carousel in reverse order
                for (var i = 0; i < sortedSlides.length; i++) {
                    $('.slick-slider').slick('slickAdd', sortedSlides[i]);
                }
            }
            /**chem merge*/
            $(".carousel").on("afterChange", function () {
                var currentActiveElement = document.activeElement;
                var activeSlide;
                if ($(currentActiveElement).hasClass('slick-arrow')) {
                    activeSlide = $(currentActiveElement).siblings('.slick-list').children().children('.slick-slide.slick-current.slick-active');
                }
                else {
                    activeSlide = $(currentActiveElement).parents().siblings('.slick-list').children().children('.slick-slide.slick-current.slick-active');
                }

                if ($(document.activeElement).parents().hasClass('c03-carousel')) {
                    var SRele = document.getElementById("carouselSRtext");
                    if (SRele) {
                        SRele.remove();
                    }
                    var srText = activeSlide.attr('data-srtext');
                    if (srText) {
                        activeSlide.parents('.c03-carousel').append('<div class="visually-hidden" id="carouselSRtext" role="alert">' + srText + '</div>');
                    }
                }
                else {
                }
                lazyLoadImg();
            });

            $(".carousel").on("beforeChange", function () {
                //   $(".slick-slide.slick-current.slick-active .b05-button *").attr("aria-hidden", "true");
                //   $(".slick-slide.slick-current.slick-active .b03-image *").attr("aria-hidden", "true");
                //   var currentActiveElement2 = document.activeElement;
                //   var activeSlide2 = $(currentActiveElement2).parents().siblings('.slick-list').children().children('.slick-slide.slick-current.slick-active');
                //   $(activeSlide2).removeAttr("aria-relevant");
                //   $(activeSlide2).removeAttr("aria-live");
            });

            $(".slick-list").removeAttr("aria-live");
            $(".slick-slide").attr("aria-relevant", "additions");
            // $(".slick-slide").attr("aria-live", "assertive");

            setTimeout(function () {
                if (custom.autoplay) {
                    $('.slick-arrow').on('mouseover', function () {
                        self.slick('slickPause');
                    });
                    $('.slick-arrow').on('mouseout', function () {
                        self.slick('slickPlay');
                    });
                }
                /*chem merge*/
                if ($('.slick-slide').length === 1) { $('li.slick-active').css('display', 'none'); }
                /*chem merge*/
                if (self[0].slick.slideCount === 1) {
                    var removeTag = self.children('ul').children('li.slick-active');
                    removeTag.css('display', 'none');
                    var ulTag = self.children('ul');
                    ulTag.css('display', 'none');
                }
                $('[data-slick-index] button,[data-slick-index] a').attr("tabindex", "-1");
                $('[data-slick-index="' + 0 + '"] button,[data-slick-index="' + 0 + '"] a').attr("tabindex", "0");
            }, 1000);
            setTimeout(function () {
                $('.slick-dots li').each(function () {
                    $(this).children('a').attr('role', 'tab');
                    if ($(this)[0].className === 'slick-active') {
                        $(this).children('a').attr('aria-selected', 'true');
                    } else {
                        $(this).children('a').attr('aria-selected', 'false');
                    }
                });
            }, 1000);
            self.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                var currentActiveElement = document.activeElement;
                var activeSlide = $(currentActiveElement).parents().siblings('.slick-list').children().children('.slick-slide.slick-current.slick-active');

                $(activeSlide).attr("aria-relevant", "additions");
                $(activeSlide).attr("aria-live", "polite");
                $(activeSlide).find('.b05-button *').attr("aria-hidden", "false");
                $(activeSlide).find('.b03-image *').attr("aria-hidden", "false");
            });
            self.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                setTimeout(function () {
                    $('.slick-dots li').each(function () {
                        $(this).children('a').attr('role', 'tab');
                        if ($(this)[0].className === 'slick-active') {
                            $(this).children('a').attr('aria-selected', 'true');
                        } else {
                            $(this).children('a').attr('aria-selected', 'false');
                        }
                    });
                }, 1000);
                var currentActiveElement2 = document.activeElement;
                var activeSlide2 = $(currentActiveElement2).parents().siblings('.slick-list').children().children('.slick-slide.slick-current.slick-active');
                $(activeSlide2).removeAttr("aria-relevant");
                $(activeSlide2).removeAttr("aria-live");
                $(activeSlide2).find('.b05-button *').attr("aria-hidden", "true");
                $(activeSlide2).find('.b03-image *').attr("aria-hidden", "true");
                $('[data-slick-index] button,[data-slick-index] a').attr("tabindex", "-1");
                $('[data-slick-index="' + nextSlide + '"] button,[data-slick-index="' + nextSlide + '"] a').attr("tabindex", "0");
                $('[data-slick-index="' + 0 + '"] button,[data-slick-index="' + 0 + '"] a').attr("tabindex", "0");

                if ($(".c03-carousel").find(".vjs-playing").length >= 2 && $(".c03-carousel").find(".slick-active").length) {
                    $(".c03-carousel").find(".vjs-playing").get(1).click();
                }
                else {
                    var carousel = $(event.currentTarget).closest('.c03-carousel');
                    carousel.find('.slick-active [id*="wid"]').each(function () {
                        if (videoLoaded) {
                            this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        }
                    });
                }
            });
        });
        lazyLoadImg();
    }
    $(document).ready(function () {
        setTimeout(function () {
            lazyLoadImg();
        }, 2000);
    });
    function disableAutoTagging() {
        $('.carousel .pager, .carousel .slick-prev, .carousel .slick-next').data('analytics', { manual: true });
    }

    function bindEvents() {
        var carouselLinks = $('.slick-slide [data-bs-toggle="modal"]');
        carouselLinks.each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
                openModal(this);
            });
        });
        var modalCloseButtons = $('.slick-slide [data-bs-dismiss="modal"]');
        modalCloseButtons.each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
                closeModal(this);
            });
        });
    }

    function openModal(elem) {
        var ta = $(elem).data('target');
        $(ta).modal('show');
    }

    function closeModal(elem) {
        var ta = $(elem).closest('.modal');
        $(ta).modal('hide');
    }
}(window.jQuery));

// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.c03-carousel",
        "codeId": "c03",
        "events": [
            {
                "eventTarget": ".slick-next",
                "eventType": "click",
                "eventName": "C03_CarouselNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "carousel",
                    "componentId": "c03",
                    "eventType": "carousel click",
                    "elementType": "arrow icon",
                    "elementText": "",
                    "listOrdinal": "",
                    //merged from chemicals
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'event1': '',
                    'eventCategory': '',
                    'eventAction': ''
                    //merged from chemicals
                }
            },
            {
                "eventTarget": ".slick-prev",
                "eventType": "click",
                "eventName": "C03_CarouselNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "carousel",
                    "componentId": "c03",
                    "eventType": "carousel click",
                    "elementType": "arrow icon",
                    "elementText": "",
                    "listOrdinal": "",
                    //merged from chemicals
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'event1': '',
                    'eventCategory': 'UX',
                    'eventAction': ''
                    //merged from chemicals
                }
            },
            {
                "eventTarget": ".slick-dots li a.pager",
                "eventType": "click",
                "eventName": "C03_CarouselNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "carousel",
                    "componentId": "c03",
                    "eventType": "carousel click",
                    "elementType": [
                        {
                            "rule": "$('> img', $(context)).length > 0",
                            "value": "thumbnail"
                        },
                        {
                            "rule": "true", //The conditions should always exclusive of each other, default condition should always be the last one
                            "value": "dot"
                        }
                    ],
                    "elementText": "",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": "li"
                    },
                    //merged from chemicals
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'event1': 'gaCustomEvents_carousel_dots',
                    'eventCategory': 'UX',
                    'eventAction': 'Clicked on Carousel dots'
                    //merged from chemicals
                }
            }
        ]
    },
    {
        "target": ".carousel-container",
        "codeId": "c03",
        "events": [
            {
                "eventTarget": ".slick-next",
                "eventType": "click",
                "eventName": "C03_CarouselNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "carousel",
                    "componentId": "c03",
                    "eventType": "carousel click",
                    "elementType": "arrow icon",
                    "elementText": "",
                    "listOrdinal": "",
                    //merged from chemicals
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'event1': '',
                    'eventCategory': '',
                    'eventAction': ''
                    //merged from chemicals
                }
            },
            {
                "eventTarget": ".slick-prev",
                "eventType": "click",
                "eventName": "C03_CarouselNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "carousel",
                    "componentId": "c03",
                    "eventType": "carousel click",
                    "elementType": "arrow icon",
                    "elementText": "",
                    "listOrdinal": "",
                    //merged from chemicals
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'event1': '',
                    'eventCategory': 'UX',
                    'eventAction': ''
                    //merged from chemicals
                }
            },
            {
                "eventTarget": ".slick-dots button",
                "eventType": "click",
                "eventName": "C03_CarouselNavigationClick",
                "tags": {
                    "event": "navigation",
                    "componentName": "carousel",
                    "componentId": "c03",
                    "eventType": "carousel click",
                    "elementType": [
                        {
                            "rule": "$('> img', $(context)).length > 0",
                            "value": "thumbnail"
                        },
                        {
                            "rule": "true", //The conditions should always exclusive of each other, default condition should always be the last one
                            "value": "dot"
                        }
                    ],
                    "elementText": "",
                    "listOrdinal": {
                        "ref": ".component",
                        "ele": "li"
                    },
                    //merged from chemicals
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'environment': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': "",
                    'event1': 'gaCustomEvents_carousel_dots',
                    'eventCategory': 'UX',
                    'eventAction': 'Clicked on Carousel dots'
                    //merged from chemicals
                }
            }
        ]
    },
)